import { Injectable, inject } from '@angular/core';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events';
import { MarginExpensesStore } from './margin-expenses.store';
import { MarginExpense } from '../../models/margin-expenses.model';

@Injectable({ providedIn: 'root' })
export class MarginExpensesReducer {
    private readonly eventBus = inject(EventBusService);
    private readonly marginExpensesStore = inject(MarginExpensesStore);

    constructor() {
        this.listenToMarginExpenseEvents();
    }

    private listenToMarginExpenseEvents() {
        this.eventBus.on(LocumsMarginCalculatorEvents.EXPENSE_ADDED).subscribe((event: EventPayload) => {
            const marginExpense: MarginExpense = {
                marginExpenseTypeId: event.payload.marginExpenseTypeId as number,
                marginExpenseAttributesId: null,
                value: null
            };

            this.marginExpensesStore.addMarginExpense(marginExpense);
        });

        this.eventBus.on(LocumsMarginCalculatorEvents.EXPENSE_REMOVED).subscribe((event: EventPayload) => {
            this.marginExpensesStore.removeMarginExpense(event.payload.marginExpenseTypeId);
        });
    }
}
